<template>
  <v-container>
  <v-card>

      <DetallesApelacion
        v-if="cuenta_detalles"
        :cuenta="cuenta_detalles"
        :apelacion="apelacion"
        :role="roleUser"
        @closeModal="$router.push({ name:'Tocas' })"
      >
      </DetallesApelacion>

      <SubirResolucion
        v-if="cuenta_detalles && (roleUser == 'magistrado' || roleUser == 'relator')"
        :item="cuenta_detalles"
         @updateCuenta="updateCuenta($event)"
      >
      </SubirResolucion>

      <NewObservacion
        v-if="cuenta_detalles && cuenta_detalles.status <= 42"
        :item="cuenta_detalles"
        :role="roleUser"
      >
      </NewObservacion>
    </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import { VueEditor } from 'vue2-editor';
  import NewObservacion from "../../components/NewObservacion";
  import DetallesApelacion from "../../components/DetallesApelacion";
  import SubirResolucion from "@/components/SubirResolucion";

  export default {
    components: {
       NewObservacion, DetallesApelacion, SubirResolucion
    },
    props: {
      source: String
    },
    data(){
      return{
        apelacion: null,
        cuenta_detalles: null,
        cuenta: {},
      }
    },
    computed: {
      formTitle () {
        return 'Add Observación'
      },
      ...mapGetters(["currentUser", "roleUser", "currentCuenta"]),
    },
    mounted() {
      this.cuenta_id = JSON.parse(localStorage.getItem("currentCuenta"))
      this.getCuenta()
    },
    methods:{ 
      getCuenta(){
        this.$store.dispatch("SHOW_CUENTA", {
          url:"/cuenta/"+ this.cuenta_id
        }).then((response) => {
          this.cuenta_detalles = response.data.data.cuenta
          this.apelacion = response.data.data.cuenta.apelacion
        }).catch(err => {
          console.log(err);
        });
      },
      updateCuenta (val){
        this.cuenta_detalles.resolucion_proyecto = val
      }
    }
  }
</script>

<style media="screen">
  .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgb(62 61 61 / 87%);
  }
  .table {
    border-collapse:collapse;
    width: 100%;
  }

  .format_table {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
</style>
